module.exports = __webpack_public_path__ + "static/media/ic_disconnected.ab4eb803.svg";